// eslint-disable-next-line no-shadow
export enum methodTypeEnum {
  system = 'System',
  static = 'Static',
  singleton = 'Singleton'
}
